import React, { FC } from 'react';
import { StyledContainer, StyledScrollContainer } from 'components/Container/styled';
import { ContainerProps } from 'components/Container/types';

const Container: FC<ContainerProps> = ({ children, width, center }) => {
  return (
    <StyledScrollContainer>
      <StyledContainer center={center}>
        {children}
      </StyledContainer>
    </StyledScrollContainer>
  );
};

export default Container;
